// extracted by mini-css-extract-plugin
export default {"description":"InstrumentalConfirmModal-module__description--JOiii","actions":"InstrumentalConfirmModal-module__actions--Pu8xO"};